import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IInventoryCategoryState {
    data: Array<IInventoryCategory> | null;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: ILoading;
    addInventoryCategoryLoading: boolean;
    addInventoryCategorySuccess: boolean;
    inventoryCategoryDetails: IInventoryCategory | null;
}

// Define the initial state using that type
const initialState: IInventoryCategoryState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    addInventoryCategoryLoading: false,
    addInventoryCategorySuccess: false,
    inventoryCategoryDetails: null
};

export const inventoryCategorySlice = createSlice({
    name: 'inventoryCategory',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.addInventoryCategoryLoading = action.payload
                .addInventoryCategoryLoading
                ? action.payload.addInventoryCategoryLoading
                : false;
            state.addInventoryCategorySuccess = action.payload
                .addInventoryCategorySuccess
                ? action.payload.addInventoryCategorySuccess
                : false;
        },
        resetLoading: (state, action) => {
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.addInventoryCategoryLoading = action.payload
                .addInventoryCategoryLoading
                ? action.payload.addInventoryCategoryLoading
                : false;
            state.addInventoryCategorySuccess = action.payload
                .addInventoryCategorySuccess
                ? action.payload.addInventoryCategorySuccess
                : false;
        },
        replaceInventoryCategory: (state, action) => {
            state.data = action.payload.data;
            state.pageSize = action.payload.pageSize;
            state.pageNumber = action.payload.pageNumber;
            state.totalCount = action.payload.totalCount;
        },
        addInventoryCategory: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateInventoryCategory: (state, action) => {
            const { data } = action.payload;
            if (state.data) {
              const index = state.data.findIndex(item => item.id === data.id);
              if (index !== -1) {
                state.data[index] = data;
              }
            }
            state.inventoryCategoryDetails = data;
          },
        deleteInventoryCategory: (state, action) => {
            const inventoryCategoryToRemove: IInventoryCategory =
                action.payload.data;
            const newInventoryCategoryData = state.data && state.data.filter(
                (inventoryCategory: IInventoryCategory) => {
                    return (
                        inventoryCategory.id !== inventoryCategoryToRemove.id
                    );
                }
            );
            state.data = newInventoryCategoryData;
            state.totalCount = state.totalCount - 1;
        },
        setInventoryCategoryDetails: (state, action) => {
            state.inventoryCategoryDetails = action.payload.data;
        }
    },
});

export const inventoryCategoryActions = inventoryCategorySlice.actions;

export default inventoryCategorySlice.reducer;
